<template>
  <ul class="tabs__list tabs__list--underline mb-10">
    <li
      v-for="title in tabTitles"
      :key="title"
      class="tabs__list-item"
      :class="{ 'tabs__list-item--active': title == selectedTitle }"
      @click="selectedTitle = title"
    >
      {{ title }}
    </li>
  </ul>
  <slot></slot>
</template>

<script>
import { computed } from "vue";

export default {
  name: "ContentTabs",
  data() {
    return {
      tabTitles: [],
      selectedTitle: "",
    };
  },
  created() {
    this.syncTabTitles();
  },
  updated() {
    this.syncTabTitles();
  },
  methods: {
    syncTabTitles() {
      const titles = (this.$slots.default?.() || [])
        .filter((vnode) => vnode?.props?.title)
        .map((vnode) => vnode.props.title);
      const titlesKey = titles.join("\0");
      const prevKey = this.tabTitles.join("\0");
      if (titlesKey === prevKey) return;

      this.tabTitles = titles;
      if (!titles.includes(this.selectedTitle)) {
        this.selectedTitle = titles[0] || "";
      }
    },
  },
  provide() {
    return {
      selectedTab: computed(() => this.selectedTitle),
    };
  },
};
</script>
